<template>
    <div>
        <div class="page-title">Provided Offer</div>
        <div class="page-box">
            <div class="page-box-title">
                <el-dropdown v-show="multipleSelection.length !==0" split-button @command="handleCommand">
                    {{multipleSelection.length}} User selected
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="b">Batch Send Announcement & Email </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button v-show="multipleSelection.length ==0" type="primary" @click="show3 = !show3">Filter</el-button>
            </div>
            <div class="search-box">
                <el-collapse-transition>
                <el-form label-width="180px" v-show="show3" :model="formLabelAlign">
                    <el-form-item label="Applicant">
                        <el-input v-model="formLabelAlign.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="warning" @click="onSubmit">Search</el-button>
                        <el-button icon="el-icon-refresh-left" @click="onReset">Reset</el-button>
                    </el-form-item>
                </el-form>
                </el-collapse-transition>
            </div>
            <el-table
            :data="providedOffers"
            @selection-change="handleSelectionChange"
            style="width: 100%;">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="applicationForm.registrationNo"
                    label="Registration"
                    >
                </el-table-column>
                <el-table-column
                    label="Applicant"
                    >
                    <template slot-scope="{row}">
                        <span v-if="row.applicationForm.applicantName">{{JSON.parse(row.applicationForm.applicantName).en || ''}} {{JSON.parse(row.applicationForm.applicantName).zh_tc || ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Response">
                    <template slot-scope="{row}">
                             <span>{{row.replyType | providedOfferReplyType}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="delegateName"
                    label="Delegate Name">
                </el-table-column>
                <el-table-column
                    prop="delegateHkid"
                    label="Delegate HKID">
                </el-table-column>
            </el-table>
            <loadingSlotDialog @close="close" :centerDialogVisible="centerDialogVisible">
                 <batchSendAnnouncement @close="closeCenter" :formType="formType" :applicationFormIds="applicationFormIds"></batchSendAnnouncement>
            </loadingSlotDialog>
        </div>
    </div>
</template>

<script>
    import {getProvidedOffers} from '@/api/admin/notification'
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import batchSendAnnouncement from '@/components/batchSendAnnouncement'
    export default {
         props:{
          formType:{
            type:Number,
            default:0
          }
        },
        components:{loadingSlotDialog,batchSendAnnouncement},
        data() {
            return {
                show3:true,
                applicationFormIds:[],
                multipleSelection:[],
                providedOffers:[],
                centerDialogVisible:false,
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: ''
                }
            }
        },
         watch:{
            formType:{
                handler(){
                    this.getProvidedOffers()
                },
                deep:true,
                immediate:true
            }
        },
        methods:{
            onReset(){
              this.formLabelAlign.name = null
              this.getProvidedOffers()
            },
            closeCenter(){
                this.centerDialogVisible = false
                this.getProvidedOffers()
            },
            onSubmit(){
                this.getProvidedOffers()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            close(v){
                this.centerDialogVisible = v
            },
            handleCommand(v){
                if(v=='b'){
                    this.applicationFormIds = this.multipleSelection.map((v)=>{
                            return v.id
                    })
                    this.centerDialogVisible = true
                }
            },
            getProvidedOffers(){
               let from = {
                    likeApplicant:this.formLabelAlign.name || null,
                    formType:this.formType
                }
                getProvidedOffers(from).then((v)=>{
                     this.providedOffers = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
}
.page-box-title{
    display: flex;
    border-bottom: 1px solid #707070;
    justify-content: space-between;
    padding: 0 47px;
    padding-top:46px;
    padding-bottom: 27px;
}
.search-box{
    padding-top: 50px;
    padding-bottom: 40px;
    padding-left: 50px;
    padding-right: 50px;
}
 .el-button--primary {
    width: auto;
    background-color:  #060C60;
    border-color: #060C60;
    font-size: 20px;
    font-weight: bold;
  }
</style>